export default __webpack_public_path__ + "static/media/travel.6273f7a1.png";